import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';
import { maps, mapTabConfig } from 'src/app/core/constants/core.constant';
import { NUMBER } from 'src/app/core/enum/core.enum';
import { AuthService } from 'src/app/core/services/auth-service/auth.service';
import { CompanyService } from 'src/app/feature/studio-portal/services/company-service/company.service';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})
export class MapsComponent implements OnInit {
  constants = maps;
  number = NUMBER;
  portalType: string;
  selectedTab: string = this.constants.main_lot_tab;
  isAuthenticated: boolean = false;
  mapContent: any;
  mapConfig = mapTabConfig;
  isChangeLocationHide = false;
 constructor(private readonly authService: AuthService,private readonly companyService: CompanyService,private readonly sanitizer: DomSanitizer) {}

  /**
    * selectTab() - method to update the currently selected tab.
    * @param tab - The identifier for the tab to be selected. This is typically a string that corresponds to one of the available tabs.
   */
  selectTab(tab: string): void {
    window.scrollTo(0,0);
    this.selectedTab = tab;

    this.mapApiProd(this.selectedTab);
  }
  /**
   * onSelectChange() - method to render different tabs after clicking on the button 
   * @param event - The change event object associated with the select element.
  */
  onSelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedTab = selectElement.value;
    this.mapApiProd(this.selectedTab);
  }


  ngOnInit(): void {
    this.checkAuthentication();
    this.mapApiProd(this.selectedTab);
  }

  /**
 * checkAuthentication() - Asynchronously checks the user's authentication status.
 */
  private async checkAuthentication(): Promise<void> {
    this.isAuthenticated = await this.authService.isAuthenticated();
    if (this.isAuthenticated) {
      const userProfileData = localStorage.getItem('user-profile');
      if (userProfileData) {
        const userProfile = JSON.parse(userProfileData);
        this.setPortalType(userProfile);
      }
    }
  }

  /**
 * setPortalType() - Sets the portalType property based on the userTypeId from the user profile.
 * @param userProfile - An object containing user profile information, which includes userTypeId.
 */
  private setPortalType(userProfile: any): void {
    if (userProfile.userTypeId === 1) {
      this.portalType = "customer";
    } else if (userProfile.userTypeId === 2) {
      this.portalType = "studio";
    }
  }
  
  /**
   * mapApiProd() - method to call map url
   * * @param selectTab - The identifier for the tab to be selected. This is typically a string that corresponds to one of the available tabs.
  */
 mapApiProd(selectTab: string): void {
    const url = 'https://client.wb.com/maps/';

    this.companyService.getHtmlContent(url).subscribe(
      (content) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');

        const tabConfig = this.mapConfig;
  
        const selectedTabConfig = tabConfig[selectTab];
        let contentHtml = '';
  
        if (selectedTabConfig) {
          const headingElement = _.find(
            doc.body.querySelectorAll('h2'),
            h2 => _.trim(h2.textContent) === selectedTabConfig.heading
          );
  
          if (headingElement) {
            const iconListDiv = _.find(
              doc.body.querySelectorAll('.elementor-icon-list-items'),
              list => {
                const linkText = list.querySelector('span.elementor-icon-list-text');
                return linkText && _.trim(linkText.textContent) === selectedTabConfig.linkText;
              }
            );
            
  
            if (iconListDiv) {
              // Modify the span elements to include the 'text-link' class
              const links = iconListDiv.querySelectorAll('span.elementor-icon-list-text');
              _.forEach(links, link => {
                link.classList.add('text-link-maps'); // Add class using native DOM API
              });
              contentHtml += iconListDiv.outerHTML; 
            } 
          } 
        } 
  
        const camelCaseHeading = selectedTabConfig.heading
          .toLowerCase() 
          .replace(/\b\w/g, (match) => match.toUpperCase()); 
          const finalContentHtml = `<h2 class="elementor-heading-title elementor-size-default pb-0">${selectedTabConfig.headingFormat}</h2>${contentHtml}`;
  
        this.mapContent = this.sanitizer.bypassSecurityTrustHtml(finalContentHtml);
      },
      (error) => {
        console.error('Error fetching HTML content:', error);
      }
    );
}
}
